import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import { Button, Tooltip } from "@material-ui/core";
import React from "react";
import { SelectionUiWrapper } from "./selectionUiWrapper";
import './selectionMenu.css'
import { StartForm } from "../startForm/startForm";
import { LoadingBanner } from "./components/loadingBanner";

export class SelectionMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showABStartForm: false
    }
  }

  render() {
    return (
      <React.Fragment>
        <StartForm
          dataCallback={(e) => { this.props.onStartFormLoad(e) }}
          id={this.props.id}
          audienceConfig={this.props.audienceConfig}
          isShown={this.state.showABStartForm}
          onChange={(e) => { this.setState({ showABStartForm: e }) }}
        />
        <GridContainer>
          <GridItem xs={3} sm={3} md={3} lg={3} xl={3}>
            <SelectionUiWrapper showWhite={this.props.previewOrEditToggle ? true : false}>
              {this.props.previewOrEditToggle ? (
                <React.Fragment>
                  <p style={{ marginLeft: '1vw' }}><b>Audience Size</b></p>
                  <p style={{ margin: 0, textAlign: 'center' }}>
                    <b>Marketable:</b> {this.props.audienceBreakdown !== null ? this.props.audienceBreakdown.marketable.total.toLocaleString() : 0}
                  </p>
                  <p style={{ margin: 0, textAlign: 'center' }}>
                    <b>Control:</b> {this.props.audienceBreakdown !== null ? this.props.audienceBreakdown.control.total.toLocaleString() : 0}
                  </p>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Button
                    color="primary"
                    onClick={() => { this.setState({ showABStartForm: true }) }}
                    style={{ width: '100%', height: '100%' }}>Edit Audience Parameters</Button>
                </React.Fragment>
              )}
            </SelectionUiWrapper>
          </GridItem>
          <GridItem xs={6} sm={6} md={6} lg={6} xl={6}>
            {/* Loading Banner */}
            {this.props.isFetchingAudiences && (
              <LoadingBanner/>
            )}
            {this.props.previewOrEditToggle ? (
              <React.Fragment>
                <SelectionUiWrapper showWhite={false}>
                  <Tooltip title={this.props.isFetchingAudiences ? "Click me, to cancel the query" : ""}>
                    <Button
                      onClick={() => { this.props.onAudienceFetch() }}
                      color="primary"
                      style={{ width: '100%', height: '100%' }}
                    >{this.props.isFetchingAudiences ? "Fetching Counts Please Wait" : "Query Audience Counts"}</Button>
                  </Tooltip>
                </SelectionUiWrapper>
              </React.Fragment>
            ) : <h2 style={{ fontSize: 30, textAlign: 'center' }}>Audience Breakdown</h2>}
          </GridItem>
          <GridItem xs={3} sm={3} md={3} lg={3} xl={3}>
            <SelectionUiWrapper showWhite={false}>
              <Button color="primary" style={{ width: '100%', height: '100%' }} onClick={() => {
                this.props.onChangePreviewOrEditToggle(!this.props.previewOrEditToggle)
              }}>{this.props.previewOrEditToggle ? "View Audience Breakdown" : "Edit Current Filters"}</Button>
            </SelectionUiWrapper>
          </GridItem>
        </GridContainer>
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/components/selectionMenu/selectionMenu.jsx